import { FC, useState } from "react";
import LogoImages from "../../assets/images/logoSvg.svg";
import ImageContent from "../../assets/images/frame.png";
import { useAppDispatch } from "store";
import { Link, useNavigate } from "react-router-dom";
import { useRequestAuthOtp, useLoginPassword, useChangePassword, useRequestKeepAlive } from "hooks/useAuth";
import { setOtp, setMobile, setAuth, setProfileAndContact } from "store/slices/authSlice";
import styled from "@emotion/styled";
import { Button, Col, Form, Grid, Input, message, Row, Typography, Modal } from "antd";
import { css } from "@emotion/react";
import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { getAuthProfile } from "services/authAPI";
import { getFirebaseToken } from "services/firebase";
import axios from "axios";
import { backendUrl } from "../../config";

const { useBreakpoint } = Grid;

const SignInPage: FC = () => {
  const [isError, setIsError] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string>("");
  const [loginMode, setLoginMode] = useState<'phone' | 'username'>('phone');
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  const [userProfile, setUserProfile] = useState<any>(null);
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const [accessToken, setAccessToken] = useState<string>("");

  const screens = useBreakpoint();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { mutate: requestOtpAuth, isPending: isPendingOtp } = useRequestAuthOtp();
  const { mutate: loginPassword, isPending: isPendingPassword } = useLoginPassword();
  const { mutate: changePasswordMutation, isPending: isPendingChangePassword } = useChangePassword();
  const { mutate: requestKeepAlive } = useRequestKeepAlive();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    setIsError(false);
  };

  const handleSubmit = (values: any) => {
    const inputVal = values.input?.trim();

    if (loginMode === 'phone') {
      handleRequestOtp(inputVal);
    } else {
      handlePasswordLogin(inputVal, values.password);
    }
  };

  const handleRequestOtp = (mobile: string) => {
    requestOtpAuth(
      {
        mobile: mobile,
        app_name: "factory",
      },
      {
        onSuccess: (data) => {
          if (data.status === "success") {
            dispatch(setOtp({ token: data.token, refNo: data.ref_no }));
            dispatch(setMobile(mobile));
            navigate("/confirm-otp");
            message.success("ส่งข้อมูลเรียบร้อย");
          } else {
            setIsError(true);
            message.error(` ${data?.error_message}`);
          }
        },
        onError: (error) => {
          setIsError(true);
          message.error(
            "ไม่พบเบอร์โทรศัพท์หรืออีเมลนี้ในระบบ กรุณาตรวจสอบอีกครั้ง"
          );
        },
      }
    );
  };

  const handleGetFirebaseToken = () => {
    getFirebaseToken()
      .then((firebaseToken) => {
        console.log("Firebase token: ", firebaseToken);
        if (firebaseToken) {
          requestKeepAlive({ fcm_token: firebaseToken });
        }
      })
      .catch((err) =>
        console.error("An error occured while retrieving firebase token. ", err)
      );
  };

  const handlePasswordLogin = (username: string, password: string) => {
    loginPassword(
      {
        username: username,
        password: password,
      },
      {
        onSuccess: (data) => {
          if (data.status === "success") {

            if (data.profile?.is_verified === false) {

              setUserProfile(data.profile);
              setShowPasswordModal(true);

              if (data.access_token) {
                setAccessToken(data.access_token);
              }


            } else {

              if (data.access_token) {
                dispatch(setAuth({ access_token: data.access_token }));
              }

              getAuthProfile()
                .then((res) => {
                  if (res.status === "success") {
                    dispatch(
                      setProfileAndContact({
                        profile: res.profile,
                        contact: res.contact,
                      })
                    );

                    handleGetFirebaseToken();

                    message.success("เข้าสู่ระบบสำเร็จ");

                    navigate("/dashboard");
                  }
                })
                .catch((err) => {
                  message.error(`${err}`);
                  dispatch(setAuth({}));
                });
            }
          } else {
            setIsError(true);
            message.error(data?.error_message || "ข้อมูลไม่ถูกต้อง");
          }
        },
        onError: (error) => {
          setIsError(true);
          message.error("ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง");
        },
      }
    );
  };

  const handlePasswordChange = () => {
    if (newPassword !== confirmPassword) {
      message.error("รหัสผ่านไม่ตรงกัน");
      return;
    }
    if (newPassword.length < 6) {
      message.error("รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร");
      return;
    }

    //axios post change password
    axios.post(

      `${backendUrl}user/admin/change_password`, {
      password: newPassword,
    }
      , {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    )
      .then((res) => {
        if (res.status === 200) {
          message.success("เปลี่ยนรหัสผ่านสำเร็จ");
          setShowPasswordModal(false);
          if (accessToken) {
            dispatch(setAuth({ access_token: accessToken }));
          }
          getAuthProfile()
            .then((res) => {
              if (res.status === "success") {
                dispatch(
                  setProfileAndContact({
                    profile: res.profile,
                    contact: res.contact,
                  })
                );

                handleGetFirebaseToken();

                message.success("เข้าสู่ระบบสำเร็จ");

                navigate("/dashboard");
              }
            })
            .catch((err) => {
              message.error(`${err}`);
              dispatch(setAuth({}));
            });
        }
      })
      .catch((err) => {
        message.error(`${err}`);
      });

    // changePasswordMutation(
    //   {
    //     password: newPassword,
    //   },
    //   {
    //     onSuccess: (data) => {
    //       if (data.status === "success") {
    //         message.success("เปลี่ยนรหัสผ่านสำเร็จ");
    //         setShowPasswordModal(false);

    //         debugger;

    //         getAuthProfile()
    //           .then((res) => {
    //             if (res.status === "success") {
    //               dispatch(
    //                 setProfileAndContact({
    //                   profile: res.profile,
    //                   contact: res.contact,
    //                 })
    //               );

    //               handleGetFirebaseToken();

    //               message.success("เข้าสู่ระบบสำเร็จ");

    //               navigate("/dashboard");
    //             }
    //           })
    //           .catch((err) => {
    //             message.error(`${err}`);
    //             dispatch(setAuth({}));
    //           });
    //       } else {
    //         message.error(data?.error_message || "เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน");
    //       }
    //     },
    //     onError: (error) => {
    //       message.error("เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน กรุณาลองใหม่อีกครั้ง");
    //     },
    //   }
    // );
  };

  return (
    <>
      <MainSection>
        <Row gutter={[24, 0]}>
          <Col xs={{ span: 24, offset: 0 }} sm={{ span: 24, offset: 0 }} md={{ span: 12, offset: 6 }} lg={{ span: 6, offset: 9 }}  >
            <ImageSection>
              <img
                src={LogoImages}
                alt="Logo"
                width="100%"
                height="150"
                loading="lazy"
              />
            </ImageSection>
            <SectionText>
              <Typography.Title level={4}>ยินดีต้อนรับ</Typography.Title>
            </SectionText>
            <SectionText>
              <Typography.Title level={5}>เข้าสู่ระบบเพื่อใช้งานระบบ</Typography.Title>
              <Typography.Title level={5}>
                {loginMode === 'phone' ? 'เข้าสู่ระบบด้วยเบอร์โทรศัพท์' : 'เข้าสู่ระบบด้วย Username'}
              </Typography.Title>
            </SectionText>
            {isError && (
              <SectionText>
                <Typography.Text type="danger">
                  {loginMode === 'phone'
                    ? "ไม่พบเบอร์โทรศัพท์นี้ในระบบ กรุณาตรวจสอบอีกครั้ง"
                    : "ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง"
                  }
                </Typography.Text>
              </SectionText>
            )}
            <SectionInput>
              <Form
                onFinish={handleSubmit}
                layout="vertical"
                className="row-col"
                key={loginMode}
              >
                <Form.Item
                  className="username"
                  name="input"
                  rules={[
                    {
                      required: true,
                      message: loginMode === 'phone' ? "กรุณากรอกหมายเลขโทรศัพท์" : "กรุณากรอก Username",
                    },
                  ]}
                >
                  <Input
                    placeholder={loginMode === 'phone' ? "เบอร์โทรศัพท์" : "Username"}
                    autoComplete="off"
                    onChange={handleInputChange}
                    value={inputValue}
                  />
                </Form.Item>

                {loginMode === 'username' && (
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกรหัสผ่าน",
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder="รหัสผ่าน"
                      autoComplete="off"
                      iconRender={(visible) => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
                    />
                  </Form.Item>
                )}

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    loading={isPendingOtp || isPendingPassword}
                    size="large"
                  >
                    ถัดไป
                  </Button>
                </Form.Item>

                <DividerSection>
                  <DividerLine />
                  <DividerText>หรือ</DividerText>
                  <DividerLine />
                </DividerSection>

                <Form.Item style={{ marginTop: 16 }}>
                  <Button
                    type="default"
                    style={{ width: "100%" }}
                    size="large"
                    onClick={() => {
                      setLoginMode(loginMode === 'phone' ? 'username' : 'phone');
                      setInputValue('');
                      setIsError(false);
                    }}
                  >
                    {loginMode === 'phone' ? 'เข้าสู่ระบบด้วย Username' : 'เข้าสู่ระบบด้วยเบอร์โทรศัพท์'}
                  </Button>
                </Form.Item>
              </Form>
            </SectionInput>
          </Col>
        </Row>
      </MainSection>

      <Modal
        title="เปลี่ยนรหัสผ่าน"
        open={showPasswordModal}
        onOk={handlePasswordChange}
        onCancel={() => setShowPasswordModal(false)}
        okText="บันทึก"
        cancelText="ยกเลิก"
        confirmLoading={isPendingChangePassword}
      >
        <div style={{ marginBottom: 16 }}>
          <Typography.Text>
            สวัสดี {userProfile?.first_name} {userProfile?.last_name}
          </Typography.Text>
          <br />
          <Typography.Text type="secondary">
            เนื่องจากเป็นการเข้าใช้งานครั้งแรก กรุณาเปลี่ยนรหัสผ่านใหม่
          </Typography.Text>
        </div>

        <div style={{ marginBottom: 16 }}>
          <Typography.Text>รหัสผ่านใหม่:</Typography.Text>
          <Input.Password
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="กรอกรหัสผ่านใหม่"
            style={{ marginTop: 8 }}
          />
        </div>

        <div>
          <Typography.Text>ยืนยันรหัสผ่าน:</Typography.Text>
          <Input.Password
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="ยืนยันรหัสผ่านใหม่"
            style={{ marginTop: 8 }}
          />
        </div>
      </Modal>
    </>
  );
};

export default SignInPage;

const MainSection = styled.div`
  width: 100%;
  position: relative;
  min-height: 100vh;
  background-color: #fff;
`;

const SectionText = styled.div`
  width: 100%;
  margin-top: 10px;
  text-align: center;
  padding: 0 5px;
`;

const ImageSection = styled.div`
  margin-top: 50px;
`;

const SectionInput = styled.div`
  padding: 0 20px;
`;

const SectionFooter = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 10px 0;
  text-align: center;
`;

const BackgroundGradient = styled.div`
  background: linear-gradient(45deg, #34657c, #dae0e3);
  background-size: 100% 100%;
  width: 100%;
  height: 100vh;
  position: absolute;
`;

const NavOnBackground = styled.div`
  position: absolute;
  top: 0;
  left: 20;
  padding: 10px;
`;

const WrapperImageContent = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-left: 15%;
`;

const WrapperTextContent = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  margin-top: 6%;
  margin-left: 10%;
`;

const WrapperTextHeader = styled.div``;

const WrapperTextBody = styled.div`
  margin-left: 20px;
  margin-top: 20px;
`;

const DividerSection = styled.div`
  display: flex;
  align-items: center;
  margin: 24px 0 8px 0;
`;

const DividerLine = styled.div`
  flex: 1;
  height: 1px;
  background-color: #d9d9d9;
`;

const DividerText = styled.span`
  padding: 0 16px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 14px;
`;